import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Card, Text } from 'react-native-elements';

interface Props {
  title: string;
  name: string;
  phone: string;
  email: string;
}

const ContactCard: React.FC<Props> = ({ title, name, phone, email }: Props) => {
  return (
    <View style={styles.card}>
      <Card containerStyle={styles.cardContainer}>
        <Card.Title style={styles.title}>{title}</Card.Title>
        <Text style={styles.body}>{name}</Text>
        <Text style={styles.body}>Phone: {phone}</Text>
        <Text style={styles.body}>Email: {email}</Text>
      </Card>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    flex: 1,
  },
  cardContainer: {
    borderWidth: 0,
    paddingHorizontal: 15,
    marginHorizontal: 0,
  },
  title: {
    textAlign: 'left',
    color: '#303133',
    fontSize: 20,
    fontWeight: 'bold',
  },
  body: {
    color: '#777777',
  },
});

export default ContactCard;
